import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { UserProvider } from "./context/User";

const baseurl = process.env.BASEURL;

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <BrowserRouter basename={baseurl}>
    <UserProvider>
      <App />
    </UserProvider>
  </BrowserRouter>,
);
